export const worksTitle = (
    <>
        <span>Recent</span> works
    </>
);
export const worksTitleUA = (
    <>
        <span>Останні</span> напрацювання
    </>
);

export const worksNameList = [
    { value: 'all', tag: 'all' },
    { value: 'commercial', tag: 'commercial' },
    // { value: 'educational', tag: 'educational' },
    { value: 'pet projects', tag: 'pet projects' },
];
export const worksNameListUA = [
    { value: 'усі', tag: 'all' },
    { value: 'комерційні', tag: 'commercial' },
    // { value: 'навчальні', tag: 'educational' },
    { value: 'пет проєкти', tag: 'pet projects' },
];

export const worksData = [
    {
        sort: 189,
        name: 'My CV',
        stack: [
            'React.js',
            'module-CSS',
            'JSX',
            'custom Hooks',
            'Context',
            'responsive design',
        ],
        imgs: ['img/works/project-21.webp'],
        gitHub: 'https://github.com/IamOlegDub/cv',
        url: '',
        type: 'pet projects',
        info: 'Developed my own CV-page using React, styling by module CSS. Adaptive design. High estimates on lighthouse.',
    },
    {
        sort: 201,
        name: 'WePipe - video platform',
        stack: ['React Native', 'Expo', 'appwrite'],
        imgs: [
            'img/works/wepipe/1.jpg',
            'img/works/wepipe/2.jpg',
            'img/works/wepipe/3.jpg',
            'img/works/wepipe/4.jpg',
            'img/works/wepipe/5.jpg',
            'img/works/wepipe/7.jpg',
            'img/works/wepipe/8.jpg',
            'img/works/wepipe/9.jpg',
            'img/works/wepipe/10.jpg',
            'img/works/wepipe/11.jpg',
            'img/works/wepipe/12.jpg',
        ],
        gitHub: 'https://github.com/IamOlegDub/wepipe',
        videos: ['img/works/wepipe/wepipe-video-vertical.mp4'],
        url: '',
        type: 'pet projects',
        info: 'A small pet project for uploading and viewing videos. Built with React Native and connected to Appwrite. Also, authentication (login and sign-up) is implemented.',
    },
    {
        sort: 200,
        name: 'Baliprofit - Find property in Bali',
        stack: [
            'Next.js',
            'Tailwind CSS',
            'TypeScript',
            'Zustand',
            'MapBox',
            'PayPal',
            'Next Auth',
            'Next Intl',
            'Google Translation',
        ],
        imgs: [
            'img/works/baliprofit/1.png',
            'img/works/baliprofit/2.png',
            'img/works/baliprofit/3.png',
            'img/works/baliprofit/4.png',
            'img/works/baliprofit/5.png',
            'img/works/baliprofit/7.png',
            'img/works/baliprofit/8.png',
            'img/works/baliprofit/9.png',
            'img/works/baliprofit/10.png',
            'img/works/baliprofit/11.png',
            'img/works/baliprofit/12.png',
        ],
        gitHub: '',
        videos: ['img/works/baliprofit/baliprofit-video.mp4'],
        url: 'https://baliprofit.com',
        type: 'commercial',
        info: 'A sophisticated project that, like AirBnb, help people with the selection of housing for sale, rent and land plots. The main features are borrowed from Airbnb, like work with map, search, page content etc.',
    },
    {
        sort: 199,
        name: 'OTSI - calendly analog',
        stack: ['JS', 'SCSS', 'Stripe', 'integration in .NET'],
        imgs: [
            'img/works/otsi/1.png',
            'img/works/otsi/2.png',
            'img/works/otsi/3.png',
            'img/works/otsi/4.png',
            'img/works/otsi/5.png',
            'img/works/otsi/6.png',
            'img/works/otsi/7.png',
            'img/works/otsi/8.png',
            'img/works/otsi/9.png',
            'img/works/otsi/10.png',
            'img/works/otsi/11.png',
        ],
        gitHub: '',
        videos: [
            'img/works/otsi/otsi-desktop-video.mp4',
            'img/works/otsi/otsi-vertical-video.mp4',
        ],
        url: '',
        type: 'commercial',
        info: 'Modal window for booking visitation dates, customized for specific clients (similar to Calendly).',
    },
    {
        sort: 198,
        name: 'Brave exteriors - landing page',
        stack: [
            'Next (static export)',
            'Tailwind CSS',
            'TS',
            'React Hook Forms',
        ],
        imgs: [
            'img/works/brave/1.png',
            'img/works/brave/2.png',
            'img/works/brave/3.png',
            'img/works/brave/4.png',
            'img/works/brave/5.png',
            'img/works/brave/6.png',
        ],
        gitHub: '',
        videos: [],
        url: '',
        type: 'commercial',
        info: 'I was responsible for reviewing the work on the site, but many mistakes made by the developer led to the fact that I completed the site myself.',
    },
    {
        sort: 197,
        name: 'Crypto',
        stack: [
            'Next (static export)',
            'Tailwind CSS',
            'TS',
            'React Hook Forms',
        ],
        imgs: [
            'img/works/crypto/1.png',
            'img/works/crypto/2.png',
            'img/works/crypto/3.png',
            'img/works/crypto/4.png',
            'img/works/crypto/5.png',
            'img/works/crypto/6.png',
            'img/works/crypto/7.png',
            'img/works/crypto/8.png',
            'img/works/crypto/9.png',
            'img/works/crypto/10.png',
        ],
        gitHub: '',
        videos: [],
        url: '',
        type: 'commercial',
        info: 'Web application for users and technicians. Simple service that fetch data from backend',
    },
    {
        sort: 196,
        name: 'DLTS - service',
        stack: ['React', 'JS', 'CSS', 'HTML (.NET (Razor pages))'],
        imgs: ['img/works/dlts/1.png'],
        gitHub: '',
        videos: [],
        url: '',
        type: 'commercial',
        info: 'I was responsible for making changes and improvements asked by a client. There were several projects some of them where related with each others. Back was written with .NET, front - Razor pages or React. I was responsible for front part. DLTS is a leading safety and training company specializing in the professional development of truck drivers and industrial-vehicle operators across the United States. Focused on innovation and efficiency, DLTS sought to overhaul its existing manual processes, previously managed through Excel spreadsheets, by implementing a comprehensive technology system. The goal was to streamline training, project management, customer relationship management, and real-time tracking of instructor-led training',
    },
    {
        sort: 195,
        name: 'PGT - business card site',
        stack: ['Next', 'TS', 'Tailwind CSS'],
        imgs: ['img/works/pgt/1.png'],
        gitHub: '',
        videos: ['img/works/pgt/pgt-1.mp4'],
        url: 'https://pickrellglobaltechnologies.com/resources/case-studies/',
        type: 'commercial',
        info: 'Company portfolio website built with Next.js. Several projects from one client from USA. Cooperation for more than 10 months',
    },
    {
        sort: 194,
        name: 'Syncify - service to connect to shopify',
        stack: ['React', 'Tailwind CSS'],
        imgs: [
            'img/works/sync/1.png',
            'img/works/sync/2.png',
            'img/works/sync/3.png',
            'img/works/sync/4.png',
            'img/works/sync/5.png',
            'img/works/sync/6.png',
            'img/works/sync/7.png',
            'img/works/sync/8.png',
            'img/works/sync/9.png',
            'img/works/sync/10.png',
        ],
        gitHub: '',
        videos: [],
        url: '',
        type: 'commercial',
        info: 'Web application for Shopify integration. “The client was satisfied and a few months later asked for cooperation again.” ',
    },
    {
        sort: 20,
        name: 'Sign In',
        stack: [
            'React',
            'TypeScript',
            'Redux Toolkit',
            'Redux Thunk',
            'Firebase',
            'React-router-dom',
            'React Hook Form',
            'yup',
            'Material UI',
        ],
        imgs: ['img/works/project-36.webp'],
        gitHub: 'https://github.com/IamOlegDub/sign-in',
        url: 'https://heartfelt-capybara-965af4.netlify.app/',
        type: 'pet projects',
        info: 'I created a site where you can register and go to the home page and log out.',
    },
    {
        sort: 19,
        name: 'Quiz',
        stack: [
            'React',
            'React-CLI',
            'Open API',
            'usePortal',
            'SCSS',
            'React-router-dom',
            'react-google-charts',
            'localStorage',
        ],
        imgs: ['img/works/project-34.webp'],
        gitHub: 'https://github.com/IamOlegDub/quiz',
        url: 'https://tiny-cocada-593fa4.netlify.app/',
        type: 'pet projects',
        info: 'I have developed an quiz application where user have an option to choose the category with different difficulty levels. Also there is a button for random category and level. After answering all the questions, the user gets to the results page. There you can see the score for the last game and for all previous ones. There is also a chart that shows the number of correct answers and a histogram that shows the favorite categories.',
    },
    {
        sort: 18,
        name: 'Wordpress slider',
        stack: ['JavaScript', 'Wordpress'],
        imgs: ['img/works/project-35.webp'],
        gitHub: '',
        url: 'https://aeron.no/',
        type: 'commercial',
        info: 'I installed a slider on a site written on wordpress',
    },
    {
        sort: 17,
        name: 'Git user finder',
        stack: ['TypeScript', 'React', 'React-CLI'],
        imgs: ['img/works/project-32.webp'],
        gitHub: 'https://github.com/IamOlegDub/useFinder',
        url: 'https://inquisitive-toffee-012e06.netlify.app/',
        type: 'pet projects',
        info: 'I have developed a TypeScript application that uses the GitHub API to search for a user based on its username.',
    },
    {
        sort: 16,
        name: 'Wordpress Avada menu',
        stack: ['JavaScript', 'Avada', 'Wordpress'],
        imgs: ['img/works/project-33.webp'],
        gitHub: '',
        url: 'https://aeron.no/',
        type: 'commercial',
        info: 'I made edits to a website that was built on the WordPress platform using an additional plugin Avada. Specifically, I added JavaScript to the existing code that modified the functionality of the menu, both for desktop and small screens.',
    },
    {
        sort: 15,
        name: 'Notes',
        stack: [
            'React.js',
            'IndexedDB',
            'Custom Hooks',
            'Markdown',
            'Context',
            'SCSS',
        ],
        imgs: ['img/works/project-31.webp'],
        gitHub: 'https://github.com/IamOlegDub/notes',
        url: 'https://teal-sopapillas-df11cc.netlify.app/',
        type: 'pet projects',
        info: 'I developed a simplified replica of the Notes application from the Apple macOS operating system using React.js.',
    },
    {
        sort: 14,
        name: 'Currency converter',
        stack: ['React.js', 'module-CSS', 'JSX', 'API'],
        imgs: ['img/works/project-22.webp'],
        gitHub: 'https://github.com/IamOlegDub/curr-conv',
        url: 'https://polite-centaur-9d2434.netlify.app/',
        type: 'pet projects',
        info: 'I developed a mini currency converter that takes data from an open, free API. The header displays the rates for two currencies, and the converter is located in the middle of the page. The design is adaptive.',
    },
    {
        sort: 13,
        name: 'First commercial experience',
        stack: ['JS', 'SCSS', 'HTML', 'PHP', 'GULP'],
        imgs: ['img/works/project-20.webp'],
        gitHub: '',
        url: 'https://www.softpartners.com.ua/',
        type: 'commercial',
        info: 'Developed a web page with 11 pages. There are moving gradient CSS animation, slick slider, sending email by php, Google captcha, email validation, burger menu, adaptive design',
    },
    {
        sort: 12,
        name: 'Spaceflight News',
        stack: ['React', 'ReactRouter', 'MUI', 'useContext', 'fetch API'],
        gitHub: 'https://github.com/IamOlegDub/nasa-task.git',
        imgs: ['img/works/project-18.webp'],
        url: 'https://lucky-biscotti-0fe994.netlify.app/',
        type: 'pet projects',
        info: 'Developed a small test task. It shows cards with image, title and description fetching from open API. The card is clickable and the click route to the next page with full title and description',
    },
    {
        sort: 11,
        name: 'Tic tac toe',
        stack: ['React', 'useState'],
        gitHub: 'https://github.com/IamOlegDub/tic-tac-toe.git',
        url: 'https://legendary-pika-8ea928.netlify.app/',
        type: 'pet projects',
        imgs: ['img/works/project-17.webp'],
        info: 'Developed a small simple allknown game with crosses and zeroes.',
    },
    // {
    //     sort: 4,
    //     name: 'Landing',
    //     stack: ['HTML', 'CSS', 'JS', 'GULP'],
    //     gitHub: 'https://github.com/IamOlegDub/landing-updated.git',
    //     url: 'http://olegdub.atwebpages.com/else/bukee',
    //     type: 'educational',
    //     imgs: ['img/works/project-16.webp'],
    //     info: 'Developed a landing page using Gulp pack and making adaptive layout',
    // },
    {
        sort: 9,
        name: 'Food Order',
        stack: [
            'React',
            'useState',
            'useReducer',
            'useContext',
            'useEffect',
            'useRef',
        ],
        gitHub: 'https://github.com/IamOlegDub/kebab.git',
        url: 'https://celebrated-monstera-675bd9.netlify.app/',
        type: 'pet projects',
        imgs: ['img/works/project-14.webp'],
        info: 'Developed a small online food order site with an active cart.',
    },
    // {
    //     sort: 8,
    //     name: 'Costs Manager',
    //     stack: ['React'],
    //     gitHub: 'https://github.com/IamOlegDub/costs-manager__react.git',
    //     url: 'https://comfy-gecko-60f6b3.netlify.app/',
    //     type: 'educational',
    //     imgs: ['img/works/project-12.webp'],
    //     info: 'Developed a small cost manager with filtering costs by years and showing in a diagram',
    // },
    // {
    //     sort: 7,
    //     name: 'Chuck Chat',
    //     stack: ['React', 'React Router', 'API', 'Firebase'],
    //     gitHub: 'https://github.com/IamOlegDub/ChuckChat__react.git',
    //     url: 'http://olegdub.zzz.com.ua/',
    //     type: 'pet projects',
    //     imgs: ['img/works/project-11.webp'],
    //     info: "Developed a funny chat with 'facts' about Chuck Norris using API, firebase for Google authentication",
    // },
    // {
    //     sort: 6,
    //     name: 'Wallet',
    //     stack: ['React', 'API'],
    //     gitHub: 'https://github.com/IamOlegDub/wallet__react.git',
    //     url: 'https://unrivaled-banoffee-96bb5a.netlify.app/',
    //     type: 'pet projects',
    //     imgs: ['img/works/project-10.webp'],
    //     info: 'Developed a simple wallet application using API with ability to add card and cash.',
    // },
    // {
    //     sort: 5,
    //     name: 'Books shop',
    //     stack: ['React', 'Redux', 'React-Bootstrap', 'Material UI'],
    //     gitHub: 'https://github.com/IamOlegDub/book-shop-react.git',
    //     url: 'https://62de7bccb50ddd04114c696e--neon-crisp-330e03.netlify.app/',
    //     type: 'educational',
    //     imgs: ['img/works/project-9.webp'],
    //     info: 'Developed a books shop with a search panel and a cart',
    // },
    // {
    //     sort: 4,
    //     name: "Landing",
    //     stack: ["React", "ReactRouter", "MUI", "useContext", "fetch API"],
    //     gitHub: "",
    //     type: "educational",
    //     img: "img/works",
    //     info: "Developed a landing page using Gulp pack and making adaptive layout",
    // },
    // {
    //     sort: 3,
    //     name: "Landing",
    //     stack: ["React", "ReactRouter", "MUI", "useContext", "fetch API"],
    //     gitHub: "",
    //     type: "educational",
    //     img: "img/works",
    //     info: "Developed a landing page using Gulp pack and making adaptive layout",
    // },
    // {
    //     sort: 2,
    //     name: "Landing",
    //     stack: ["React", "ReactRouter", "MUI", "useContext", "fetch API"],
    //     gitHub: "",
    //     type: "educational",
    //     img: "img/works",
    //     info: "Developed a landing page using Gulp pack and making adaptive layout",
    // },
    // {
    //     sort: 1,
    //     name: "Landing",
    //     stack: ["React", "ReactRouter", "MUI", "useContext", "fetch API"],
    //     gitHub: "",
    //     type: "educational",
    //     img: "img/works",
    //     info: "Developed a landing page using Gulp pack and making adaptive layout",
    // },
];
export const worksDataUA = [
    {
        sort: 189,
        name: 'Моє резюме',
        stack: [
            'React.js',
            'module-CSS',
            'JSX',
            'custom Hooks',
            'Context',
            'responsive design',
        ],
        imgs: ['img/works/project-21.webp'],
        gitHub: 'https://github.com/IamOlegDub/cv',
        url: '',
        type: 'pet projects',
        info: 'Я розробив свою власну сторінку резюме за допомогою React, оформленням за допомогою модульного CSS. Адаптивний дизайн. Високі оцінки у Lighthouse.',
    },
    {
        sort: 201,
        name: 'WePipe - відео платформа',
        stack: ['React Native', 'Expo', 'appwrite'],
        imgs: [
            'img/works/wepipe/1.jpg',
            'img/works/wepipe/2.jpg',
            'img/works/wepipe/3.jpg',
            'img/works/wepipe/4.jpg',
            'img/works/wepipe/5.jpg',
            'img/works/wepipe/7.jpg',
            'img/works/wepipe/8.jpg',
            'img/works/wepipe/9.jpg',
            'img/works/wepipe/10.jpg',
            'img/works/wepipe/11.jpg',
            'img/works/wepipe/12.jpg',
        ],
        gitHub: 'https://github.com/IamOlegDub/wepipe',
        videos: ['img/works/wepipe/wepipe-video-vertical.mp4'],
        url: '',
        type: 'pet projects',
        info: 'Невеликий пет-проєкт для завантаження та перегляду відео. Створений на React Native з підключенням до Appwrite. Також реалізована аутентифікація (логін та реєстрація).',
    },
    {
        sort: 200,
        name: 'Baliprofit - Знайти нерухомість на Балі',
        stack: [
            'Next.js',
            'Tailwind CSS',
            'TypeScript',
            'Zustand',
            'MapBox',
            'PayPal',
            'Next Auth',
            'Next Intl',
            'Google Translation',
        ],
        imgs: [
            'img/works/baliprofit/1.png',
            'img/works/baliprofit/2.png',
            'img/works/baliprofit/3.png',
            'img/works/baliprofit/4.png',
            'img/works/baliprofit/5.png',
            'img/works/baliprofit/7.png',
            'img/works/baliprofit/8.png',
            'img/works/baliprofit/9.png',
            'img/works/baliprofit/10.png',
            'img/works/baliprofit/11.png',
            'img/works/baliprofit/12.png',
        ],
        gitHub: '',
        videos: ['img/works/baliprofit/baliprofit-video.mp4'],
        url: 'https://baliprofit.com',
        type: 'commercial',
        info: 'Складний проєкт, який, як і Airbnb, допомагає людям у виборі житла для продажу, оренди та земельних ділянок. Основні функції запозичені з Airbnb, такі як робота з картою, пошук, вміст сторінки тощо.',
    },
    {
        sort: 199,
        name: 'OTSI - аналог Calendly',
        stack: ['JS', 'SCSS', 'Stripe', 'integration in .NET'],
        imgs: [
            'img/works/otsi/1.png',
            'img/works/otsi/2.png',
            'img/works/otsi/3.png',
            'img/works/otsi/4.png',
            'img/works/otsi/5.png',
            'img/works/otsi/6.png',
            'img/works/otsi/7.png',
            'img/works/otsi/8.png',
            'img/works/otsi/9.png',
            'img/works/otsi/10.png',
            'img/works/otsi/11.png',
        ],
        gitHub: '',
        videos: [
            'img/works/otsi/otsi-desktop-video.mp4',
            'img/works/otsi/otsi-vertical-video.mp4',
        ],
        url: '',
        type: 'commercial',
        info: 'Модальне вікно для бронювання дати візиту, налаштоване під специфічних клієнтів (схоже на Calendly).',
    },
    {
        sort: 198,
        name: 'Brave exteriors - цільова сторінка',
        stack: [
            'Next (static export)',
            'Tailwind CSS',
            'TS',
            'React Hook Forms',
        ],
        imgs: [
            'img/works/brave/1.png',
            'img/works/brave/2.png',
            'img/works/brave/3.png',
            'img/works/brave/4.png',
            'img/works/brave/5.png',
            'img/works/brave/6.png',
        ],
        gitHub: '',
        videos: [],
        url: '',
        type: 'commercial',
        info: 'Я був відповідальним за перегляд роботи на сайті, але багато помилок, зроблених розробником, призвели до того, що я завершив сайт самостійно.',
    },
    {
        sort: 197,
        name: 'Crypto',
        stack: [
            'Next (static export)',
            'Tailwind CSS',
            'TS',
            'React Hook Forms',
        ],
        imgs: [
            'img/works/crypto/1.png',
            'img/works/crypto/2.png',
            'img/works/crypto/3.png',
            'img/works/crypto/4.png',
            'img/works/crypto/5.png',
            'img/works/crypto/6.png',
            'img/works/crypto/7.png',
            'img/works/crypto/8.png',
            'img/works/crypto/9.png',
            'img/works/crypto/10.png',
        ],
        gitHub: '',
        videos: [],
        url: '',
        type: 'commercial',
        info: 'Веб-додаток для користувачів та технічних спеціалістів. Простий сервіс, що отримує дані з бекенду.',
    },
    {
        sort: 196,
        name: 'DLTS - сервіс',
        stack: ['React', 'JS', 'CSS', 'HTML (.NET (Razor pages))'],
        imgs: ['img/works/dlts/1.png'],
        gitHub: '',
        videos: [],
        url: '',
        type: 'commercial',
        info: 'Я був відповідальним за внесення змін та покращень, які просив клієнт. Було кілька проєктів, деякі з яких були пов’язані між собою. Бекенд написаний на .NET, фронтенд – Razor pages або React. Я був відповідальний за фронтенд частину. DLTS є провідною компанією в сфері безпеки та навчання, що спеціалізується на професійному розвитку водіїв вантажівок та операторів промислових транспортних засобів у США. Компанія прагнула оновити свої існуючі ручні процеси, які раніше управлялися через таблиці Excel, впровадивши комплексну технологічну систему для оптимізації навчання, управління проєктами, взаємовідносин із клієнтами та відстеження інструкторських тренінгів у реальному часі.',
    },
    {
        sort: 195,
        name: 'PGT - сайт-візитка',
        stack: ['Next', 'TS', 'Tailwind CSS'],
        imgs: ['img/works/pgt/1.png'],
        gitHub: '',
        videos: ['img/works/pgt/pgt-1.mp4'],
        url: 'https://pickrellglobaltechnologies.com/resources/case-studies/',
        type: 'commercial',
        info: 'Портфоліо компанії, створене на Next.js. Кілька проєктів від одного клієнта з США. Співпраця тривала понад 10 місяців.',
    },
    {
        sort: 194,
        name: 'Syncify - сервіс для підключення до Shopify',
        stack: ['React', 'Tailwind CSS'],
        imgs: [
            'img/works/sync/1.png',
            'img/works/sync/2.png',
            'img/works/sync/3.png',
            'img/works/sync/4.png',
            'img/works/sync/5.png',
            'img/works/sync/6.png',
            'img/works/sync/7.png',
            'img/works/sync/8.png',
            'img/works/sync/9.png',
            'img/works/sync/10.png',
        ],
        gitHub: '',
        videos: [],
        url: '',
        type: 'commercial',
        info: 'Веб-додаток для інтеграції з Shopify. "Клієнт був задоволений і через кілька місяців запросив на повторну співпрацю."',
    },
    {
        sort: 19,
        name: 'Вікторина',
        stack: [
            'React',
            'React-CLI',
            'Open API',
            'usePortal',
            'SCSS',
            'React-router-dom',
            'react-google-charts',
            'localStorage',
        ],
        imgs: ['img/works/project-34.webp'],
        gitHub: 'https://github.com/IamOlegDub/quiz',
        url: 'https://tiny-cocada-593fa4.netlify.app/',
        type: 'pet projects',
        info: 'Я розробив веб-додаток-вікторину, де користувач має можливість вибрати категорію з різними рівнями складності. Також є кнопка для випадкової категорії та рівня. Відповівши на всі питання, користувач потрапляє на сторінку результатів. Там він може побачити рахунок останньої гри та всіх попередніх. Також є діаграма, яка показує кількість правильних відповідей, і гістограма, яка показує улюблені категорії.',
    },
    {
        sort: 18,
        name: 'Wordpress слайдер',
        stack: ['JavaScript', 'Wordpress'],
        imgs: ['img/works/project-35.webp'],
        gitHub: '',
        url: 'https://aeron.no/',
        type: 'commercial',
        info: 'Я встановив слайдер на сайт написаний на wordpress',
    },
    {
        sort: 17,
        name: 'Пошук користувача Github',
        stack: ['TypeScript', 'React', 'React-CLI'],
        imgs: ['img/works/project-32.webp'],
        gitHub: 'https://github.com/IamOlegDub/useFinder',
        url: 'https://inquisitive-toffee-012e06.netlify.app/',
        type: 'pet projects',
        info: 'Я розробив додаток на TypeScript, який використовує API GitHub для пошуку користувача за його іменем.',
    },
    {
        sort: 16,
        name: 'Wordpress Avada меню',
        stack: ['JavaScript', 'Avada', 'Wordpress'],
        imgs: ['img/works/project-33.webp'],
        gitHub: '',
        url: 'https://aeron.no/',
        type: 'commercial',
        info: 'Я робив правки на сайті, який було сформовано на платформі Wordpress за допомогою додаткового плагіна Avada. А конкретно в існуючий код дописував JavaScript, який змінював роботу меню, як для пк так і для малих екранів.',
    },

    {
        sort: 15,
        name: 'Нотатки',
        stack: [
            'React.js',
            'IndexedDB',
            'Custom Hooks',
            'Markdown',
            'Context',
            'SCSS',
        ],
        imgs: ['img/works/project-31.webp'],
        gitHub: 'https://github.com/IamOlegDub/notes',
        url: 'https://teal-sopapillas-df11cc.netlify.app/',
        type: 'pet projects',
        info: 'Розробив спрощену копію програми Нотатки з операційної системи Apple macOS за допомогою React.js.',
    },
    {
        sort: 14,
        name: 'Конвертер валют',
        stack: ['React.js', 'module-CSS', 'JSX', 'API'],
        imgs: ['img/works/project-22.webp'],
        gitHub: 'https://github.com/IamOlegDub/curr-conv',
        url: 'https://polite-centaur-9d2434.netlify.app/',
        type: 'pet projects',
        info: 'Я розробив міні-конвертер валют, який бере дані з відкритого безкоштовного API. Заголовок відображає курси для двох валют, а конвертер розташований у середині сторінки. Дизайн адаптивний.',
    },
    {
        sort: 13,
        name: 'Перший комерційний досвід',
        stack: ['JS', 'SCSS', 'HTML', 'PHP', 'GULP'],
        imgs: ['img/works/project-20.webp'],
        gitHub: '',
        url: 'https://www.softpartners.com.ua/',
        type: 'commercial',
        info: 'Я розробив 11-сторінковий сайт, де є анімація градієнту з використанням CSS, слайдер Slick, відправлення форми через PHP, Google Captcha, перевірка валідності електронної пошти, бургер-меню та адаптивний дизайн.',
    },
    {
        sort: 12,
        name: 'Новини космічних польотів',
        stack: ['React', 'ReactRouter', 'MUI', 'useContext', 'fetch API'],
        gitHub: 'https://github.com/IamOlegDub/nasa-task.git',
        imgs: ['img/works/project-18.webp'],
        url: 'https://lucky-biscotti-0fe994.netlify.app/',
        type: 'pet projects',
        info: 'Я розробив невелике тестовий завдання, яке показує картки з зображенням, заголовком та описом, які отримуються з відкритого API. Картки можна клікнути, і при цьому відкриється сторінка з повним заголовком та описом.',
    },
    {
        sort: 11,
        name: 'Хрестики-нулики',
        stack: ['React', 'useState'],
        gitHub: 'https://github.com/IamOlegDub/tic-tac-toe.git',
        url: 'https://legendary-pika-8ea928.netlify.app/',
        type: 'pet projects',
        imgs: ['img/works/project-17.webp'],
        info: "Я розробив невелику просту гру 'Хрестики-нулики'",
    },
    // {
    //     sort: 4,
    //     name: 'Односторінковий сайт',
    //     stack: ['HTML', 'CSS', 'JS', 'GULP'],
    //     gitHub: 'https://github.com/IamOlegDub/landing-updated.git',
    //     url: 'http://olegdub.atwebpages.com/else/bukee',
    //     type: 'educational',
    //     imgs: ['img/works/project-16.webp'],
    //     info: 'Я розробив сторінку, використовуючи набір інструментів Gulp і зробивши адаптивне оформлення.',
    // },
    {
        sort: 9,
        name: 'Замовлення їжі',
        stack: [
            'React',
            'useState',
            'useReducer',
            'useContext',
            'useEffect',
            'useRef',
        ],
        gitHub: 'https://github.com/IamOlegDub/kebab.git',
        url: 'https://celebrated-monstera-675bd9.netlify.app/',
        type: 'pet projects',
        imgs: ['img/works/project-14.webp'],
        info: 'Я розробив онлайн-сайт для замовлення їжі з активною корзиною. Можна переглядати меню, додавати товари до кошика і видаляти їх. При зміні к-сті товару, сума автоматично оновлюється.',
    },
    // {
    //     sort: 8,
    //     name: 'Менеджер витрат',
    //     stack: ['React'],
    //     gitHub: 'https://github.com/IamOlegDub/costs-manager__react.git',
    //     url: 'https://comfy-gecko-60f6b3.netlify.app/',
    //     type: 'educational',
    //     imgs: ['img/works/project-12.webp'],
    //     info: 'Я розробив менеджер витрат з можливістю фільтрування за роками та відображенням в діаграмі. Користувачі можуть вводити свої витрати і вказувати рік витрати.',
    // },
    // {
    //     sort: 7,
    //     name: 'Чак Норріс чат',
    //     stack: ['React', 'React Router', 'API', 'Firebase'],
    //     gitHub: 'https://github.com/IamOlegDub/ChuckChat__react.git',
    //     url: 'http://olegdub.zzz.com.ua/',
    //     type: 'pet projects',
    //     imgs: ['img/works/project-11.webp'],
    //     info: "Я розробив веселий чат з 'фактами' про Чака Норріса, використовуючи API та Firebase для автентифікації Google.",
    // },
    // {
    //     sort: 6,
    //     name: 'Гаманець',
    //     stack: ['React', 'API'],
    //     gitHub: 'https://github.com/IamOlegDub/wallet__react.git',
    //     url: 'https://unrivaled-banoffee-96bb5a.netlify.app/',
    //     type: 'pet projects',
    //     imgs: ['img/works/project-10.webp'],
    //     info: 'Я розробив простий додаток гаманця з можливістю додавання карти та готівки, використовується відкрите API.  ',
    // },
    // {
    //     sort: 5,
    //     name: 'Магазин книг',
    //     stack: ['React', 'Redux', 'React-Bootstrap', 'Material UI'],
    //     gitHub: 'https://github.com/IamOlegDub/book-shop-react.git',
    //     url: 'https://62de7bccb50ddd04114c696e--neon-crisp-330e03.netlify.app/',
    //     type: 'educational',
    //     imgs: ['img/works/project-9.webp'],
    //     info: 'Я розробив інтернет-магазин книг з панеллю пошуку та кошиком. Користувачі можуть переглядати список доступних книг, шукати книги за назвою або автором та додавати їх до свого кошика.',
    // },
    // {
    //     sort: 4,
    //     name: "Landing",
    //     stack: ["React", "ReactRouter", "MUI", "useContext", "fetch API"],
    //     gitHub: "",
    //     type: "educational",
    //     img: "img/works",
    //     info: "Developed a landing page using Gulp pack and making adaptive layout",
    // },
    // {
    //     sort: 3,
    //     name: "Landing",
    //     stack: ["React", "ReactRouter", "MUI", "useContext", "fetch API"],
    //     gitHub: "",
    //     type: "educational",
    //     img: "img/works",
    //     info: "Developed a landing page using Gulp pack and making adaptive layout",
    // },
    // {
    //     sort: 2,
    //     name: "Landing",
    //     stack: ["React", "ReactRouter", "MUI", "useContext", "fetch API"],
    //     gitHub: "",
    //     type: "educational",
    //     img: "img/works",
    //     info: "Developed a landing page using Gulp pack and making adaptive layout",
    // },
    // {
    //     sort: 1,
    //     name: "Landing",
    //     stack: ["React", "ReactRouter", "MUI", "useContext", "fetch API"],
    //     gitHub: "",
    //     type: "educational",
    //     img: "img/works",
    //     info: "Developed a landing page using Gulp pack and making adaptive layout",
    // },
];
